import React from "react";
import { Icon } from "../../../_components";

export function MapsBasics() {
  return (
    <div className="chronos-help-topic-page chronos-maps-basics-topic">
      <p>
        In chronicles, Maps are images that can be panned, and zoomed, and
        display in the top part of the interface. They can also have interactive
        Map Markers attached to them, which can link to Events in your Chronicle
        and articles in your world.
      </p>
      <p>
        You can have multiple Maps in a Chronicle. Each Event might link to a
        different map, if you choose. Your images don't even technically have to
        be maps: they can be character portraits, images of technological
        breakthroughs, or anything else. Get creative!
      </p>
      <h3 className="chronos-topic-header">Creating Maps</h3>
      <p>
        On set up, you'll be invited to upload a default map (optional). If you
        skip this, you'll see either your default cover image (if you've added
        one), or else the default Chronicles background.
      </p>
      <p>
        To add a new map, click the green plus button on the bottom right, then
        select{" "}
        <strong>
          <i className="fa fa-plus" />
          &nbsp;New Map
        </strong>
        . This will bring up the <strong>New Map</strong> window.
      </p>
      <p>
        The <strong>Title</strong> is shown inside the Maps Manager, to help you
        distinguish between maps. Choose something descriptive that you'll
        recognize later!
      </p>
      <p>
        The <strong>Description</strong> is not shown anywhere, and simply for
        your reference.
      </p>
      <p>
        To upload a new map, simply drag and drop the file into the{" "}
        <strong>Map Image</strong> field. The suggested size for maps is 4k x
        3.5k pixels. The suggested format is webp or jpg.
      </p>
      <p>
        The <strong>Attribution</strong> fields allow you to give credit to
        other people if the original map work is theirs. (Remember, you{" "}
        <strong>must</strong> have permission to use other people's work
        publicly!) The Attribution appears on the bottom right of the map
        section. If you've added an Attribution URL, it will open in a new tab
        when clicked.
      </p>
    </div>
  );
}
